
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import axiosCommonInstance from '../../../utils/axios/axiosCommonInstance'

const DynamicView360 = () => {
  const { id } = useParams()
  const [view360, setView360] = useState(null)
  const [loading, setLoading] = useState(true)

  const fetchview360Data = async () => {
    try {
      const response = await axiosCommonInstance.get(`dynamic360/detail/${id}`)
      setView360(response.data.result)
    } catch (error) {
      console.error('Error fetching view360 data:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchview360Data()
  }, [id])

  if (loading) {
    return <div>Loading...</div>
  }

  if (!view360) {
    return <div>No view360 data found.</div>
  }

  return (
    <div className="w-full h-screen flex flex-col justify-center items-center bg-gray-900">
      <model-viewer
        src={view360.file}
        alt="3D model"
        auto-rotate
        camera-controls
        ar
        ar-modes="webxr scene-viewer quick-look"
        style={{ width: "100%", height: "500px" }}
      ></model-viewer>
    </div>
  )
}

export default DynamicView360
